
import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios';
import Constants from '@/constants';


@Component
export default class Withdrawal extends Vue{
  checked = false;

  runWithdraw(): void  {
    if(this.checked == false) {
      // 회원탈퇴 주의사항 확인 체크를 해주세요.
      return alert(this.$t('mypage.a0003'));
    }

    // 회원탈퇴를 하시겠습니까?
    if(confirm(this.$t('mypage.c0001').toString()) == false) {
      return;
    }

    Axios.post('/mypage/withdraw', {})
    .then(r=>{
      if(r.data) {
        // 탈퇴 처리되었습니다. 이용해주셔서 감사합니다.
        alert(this.$t('mypage.a0006'));
        this.$session.destroy();
        this.$store.dispatch("updateCartCount"); //장바구니 업데이트        
        sessionStorage.removeItem(Constants.SESSION_LOGIN);
        this.$store.commit("touchKeepAlive");        
        this.$router.push({name: 'Main'})
      }
    })
    
  }
}
